module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"update_story_graph":"更新故事图谱"},"en":{"update_story_graph":"Update Story Graph"}}')
  delete Component.options._Ctor
}
